import { render, staticRenderFns } from "./BaseActionPanelStickyFooter.vue?vue&type=template&id=47132f55&scoped=true&"
import script from "./BaseActionPanelStickyFooter.vue?vue&type=script&lang=js&"
export * from "./BaseActionPanelStickyFooter.vue?vue&type=script&lang=js&"
import style0 from "./BaseActionPanelStickyFooter.vue?vue&type=style&index=0&id=47132f55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47132f55",
  null
  
)

export default component.exports